// extracted by mini-css-extract-plugin
export var closeButton = "_mc-2";
export var closeButtonIcon = "_mc-3";
export var lightboxContent = "_mc-1";
export var lightboxOverlay = "_mc-0";